import React, { useState, useEffect } from 'react';
import FrameworkList from './FrameworkList';
import FrameworkHeader from '../FrameworkHeader';
import Modal from 'react-bootstrap/Modal';
import InteractivePanel from '../InteractivePanel';
import { getFrameworksList, getJsonData } from '../../../api/frameworks';
import { checkFrameworkItemsMultiple } from '../../../Helpers/CheckTreeHelper';
import InputText from '../../Atoms/InputText';
const frameworkData = require('../../../Constants/frameworks/construction.json');

function ModalPhase({ active, close, save, saveNote, getNote, download, data, type, totalItemsSelected, limitPerFramework, subscription, itemsSelected, projectId }) {

    return (
        <>
            <Modal size="lg" className={"modal-framework p-0 m-0"} show={active} onHide={close} backdrop="static" centered>
                <Modal.Body className='tour-select-framework-items'>
                    <InteractivePanel propsData={data} close={close} save={save} saveNote={saveNote} getNote={getNote} download={download} type={type} totalItemsSelected={totalItemsSelected} limitPerFramework={limitPerFramework} subscription={subscription} itemsSelected={itemsSelected} projectId={projectId} />
                </Modal.Body>
            </Modal>

        </>
    )
}
function ModalConfirmRemove({ active, remove, close, setValue, value, alert }) {

    return (
        <>
            <Modal size="lg" className="modal-remove" show={active} onHide={close} backdrop="static" centered>
                <Modal.Header  >
                </Modal.Header>
                <Modal.Body className=''>
                    <div className='delete-text'>
                        <img src="../images/warningAlert.png" width={300}></img>
                        <h4 className='d-none d-md-block'>Are you sure you want to delete this framework? This action cannot be undone.</h4>
                        <h5 className='d-block d-md-none'>Are you sure you want to delete this project? This action cannot be undone.</h5>
                        <span>You must enter your password to confirm.</span>
                        {alert &&
                            <div className='alert alert-danger'>
                                <span>{alert}</span>
                            </div>
                        }
                        <div className='d-flex flex-row justify-content-center w-100 mt-3 input-modal-remove'>
                            <InputText label={""} name={"Password"} type={'password'} value={value} onChange={(e) => { setValue(e) }} placeholder={"Enter Password Account"} />
                        </div>
                        <div className='d-flex flex-column flex-md-row justify-content-end container-button-group mt-4 py-2'>
                            <button className='btn btn-primary mr-2' onClick={remove}>Confirm</button>
                            <button className='btn btn-secondary mr-2' onClick={close}>Cancel</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    )
}

function Construction({ projectFrameworks, projectFrameworksItems, project, saveFramework, getCustomFrameworks, removeCustomFrameworks, saveCustomFrameworkItems, saveCustomFrameworkItemsNote, getCustomFrameworkItemsNote, getCustomFrameworkItems, downloadFramework, handleShowSubscriptionsWall, subscription, codePhase, startTour, nextStep, stopTour, currentStep, setCurrentStep }) {

    const [frameworks, setFrameworks] = useState([]);
    const [selectedFrameworks, setSelectedFrameworks] = useState(projectFrameworks);
    const [listItemSelected, setListItemSelected] = useState();
    const [framework, setFramework] = useState();
    const [dataFeasibility, setDataFeasibility] = useState([]);
    const [currentFramework, setCurrentFramework] = useState([]);
    const [currentFrameworkId, setCurrentFrameworkId] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedTab, setSelectedTab] = useState('predefined');
    const [showModalPhase, setShowModalPhase] = useState(false);
    const [showModalRemove, setShowModalRemove] = useState(false);
    const [currentFrameworkToRemove, setCurrentFrameworkToRemove] = useState(0);
    const [inputPasswordValue, setInputPasswordValue] = useState("");
    const [textAlertRemove, setTextAlertRemove] = useState("");
    const [typeModal, setTypeModal] = useState('edit');
    const [totalItemsSelected, setTotalItemsSelected] = useState(0);
    const [limitPerFramework, setLimitPerFramework] = useState(0);

    const fetchProjects = async () => {
        setLoading(true);
        try {
            // Simulación de llamada a una API
            const response = await getFrameworksList(codePhase);
            updateFrameworks(response)
        } catch (error) {
            console.error('Error fetching frameworks:', error);
        } finally {
            setLoading(false);
            if (subscription.plan === 'no-plan' && codePhase === 'F') {
                let hiddenTour = localStorage.getItem('hiddenTour');
                if (hiddenTour !== "1") {
                    if (currentStep == 0) startTour();
                    if (currentStep == 1) nextStep(1);
                }
            };
        }
    };

    const fetchCustomProjects = () => {
        getCustomFrameworks(codePhase);
    }

    // useEffect(() => {        
    //     fetchCustomProjects();
    // }, []);

    useEffect(() => {
        setDataFeasibility(getJsonData(codePhase));
        fetchCustomProjects();
    }, [codePhase]);

    useEffect(() => {
        if (showModalPhase) {
            if (subscription.plan === 'no-plan' && codePhase === 'F') {
                setCurrentStep(2);
                nextStep(2);
            }
        }

        if (!showModalPhase) {
            fetchCustomProjects();
        }


    }, [showModalPhase]);

    useEffect(() => {
        setSelectedFrameworks(projectFrameworks);
    }, [projectFrameworks]);

    useEffect(() => {
        setListItemSelected(projectFrameworksItems);
        setCurrentFrameworkId(projectFrameworksItems[0]?.framework);
        setTotalItemsSelected(projectFrameworksItems.length);
        fetchCustomProjects();
    }, [projectFrameworksItems]);

    useEffect(() => {

        currentFrameworkId && checkItemsFramework(currentFrameworkId)
    }, [currentFrameworkId]);

    useEffect(() => {
        if (!showModalPhase) fetchProjects();
    }, [selectedFrameworks]);

    useEffect(() => {
    }, [frameworks]);


    const checkItemsFramework = (id) => {
        console.log(listItemSelected);

        const element = dataFeasibility.find(item => item.id === id);
        let array;
        if (listItemSelected && listItemSelected.length) {
            array = checkFrameworkItemsMultiple(listItemSelected, [element]);
            setCurrentFramework(array[0])


        } else {
            setCurrentFramework(element);
            console.log('none');
        }
    }

    const updateFrameworks = (frameworksList) => {
        // Extraer los códigos del array seleccionado
        const selectedCodes = new Map(selectedFrameworks.map(item => [item.id, item.total_items]));//Map en vez de Set

        // Actualizar el array principal
        const updatedItems = frameworksList.map(item => ({
            ...item,
            checked: selectedCodes.has(item.id), // Verificar si el code está en los seleccionados
            total_items: selectedCodes.get(item.id) || 0,
        }));

        updatedItems.sort((a, b) => b.checked - a.checked);

        setFrameworks(updatedItems);
    };

    const handleSelectFramework = (id, total_children = 0) => {

        const element = frameworks.find(item => item.id === id);

        if (element) {

            const alreadyExists = selectedFrameworks.some(item => item.id === id);


            if (!alreadyExists) {
                setSelectedFrameworks([...selectedFrameworks, element]);
            }

        }

        element.checked = true;
        saveFramework(element);
        updateFrameworks(frameworks);
        handleUpdateFramework(id, total_children);

    }

    const handleRemoveFramework = (id) => {

        if (subscription.plan === 'no-plan' && codePhase === 'F') {
            removeCustomFrameworks(id, '');
            fetchCustomProjects();
            return;
        }
        setCurrentFrameworkToRemove(id);
        setShowModalRemove(true);
    };

    const handleConfirmRemoveFramework = async () => {
        let remove = await removeCustomFrameworks(currentFrameworkToRemove, inputPasswordValue);

        if (remove.status === 'success') {
            const element = selectedFrameworks.filter(item => item.id !== currentFrameworkToRemove);
            setSelectedFrameworks(element);
            updateFrameworks(frameworks);
            setListItemSelected([])
            fetchCustomProjects();
            setTextAlertRemove("");
            setInputPasswordValue("");
            handleCloseModal();
        } else {
            setTextAlertRemove('Authentication error, please try again.');
        }
    };

    const handleChangeInputRemove = (e) => {
        setInputPasswordValue(e.target.value);
    }

    const handleCloseModal = () => {
        setShowModalPhase(false);
        setShowModalRemove(false);
        setInputPasswordValue("");
        setCurrentFrameworkToRemove("");
        setTextAlertRemove("");
        setCurrentFramework("");
        setCurrentFrameworkId(0);
    }
    const handleSaveFrameworkCloseModal = (items, autosave, props = {}) => {
        handleSaveFramework(items, props);
        if (!autosave) {
            setShowModalPhase(false);
        }
    }

    const handleUpdateFramework = (id, total_children = 0) => {

        console.log('handleUpdateFramework', id, total_children);
        getCustomFrameworkItems(id);
        setLimitPerFramework(total_children);
        const element = dataFeasibility.find(item => item.id === id);
        setCurrentFramework(element);
        //checkItemsFramework(id);
        setShowModalPhase(true);
        setTypeModal('edit');
    }

    const handleUpdateStateFramework = (id) => {

        setListItemSelected((prevList) => {
            // Verifica si el id ya existe en la lista
            const exists = prevList.some((item) => item.id === id.id);

            if (exists) {
                // Si ya existe, lo elimina
                return prevList.filter((item) => item.id !== id.id);
            } else {
                return [...prevList, id];
            }
        });

        //setListItemSelected([...listItemSelected, id])
    }

    const handleSaveFramework = (items, props = {}) => {
        saveCustomFrameworkItems(items, currentFramework, codePhase, props);
    }
    const handleSaveFrameworkNote = (currentItemNote, note, closeModal) => {
        saveCustomFrameworkItemsNote(currentFramework, currentItemNote, note);
    }

    const handlaGetFrameworkNote = async (item) => {
        let note = await getCustomFrameworkItemsNote(currentFramework, item);
        return note;
    }

    const handleShowTableContent = (id) => {
        if (subscription.plan === 'no-plan' && codePhase === 'F') {
            handleShowSubscriptionsWall();
            return;
        }
        checkItemsFramework(id);
        getCustomFrameworkItems(id);
        setShowModalPhase(true);
        setTypeModal('show');
    }

    const handleDownloadFramework = (id, name) => {
        downloadFramework(id, name);
    }

    return (
        <div>
            {showModalPhase && <ModalPhase active={showModalPhase} close={handleCloseModal} save={handleSaveFrameworkCloseModal} saveNote={handleSaveFrameworkNote} getNote={handlaGetFrameworkNote} download={handleDownloadFramework} data={currentFramework} type={typeModal} totalItemsSelected={totalItemsSelected} limitPerFramework={limitPerFramework} subscription={subscription.plan} itemsSelected={listItemSelected} projectId={project.id} />}
            <ModalConfirmRemove active={showModalRemove} remove={handleConfirmRemoveFramework} setValue={handleChangeInputRemove} close={handleCloseModal} value={inputPasswordValue} alert={textAlertRemove} />
            <FrameworkHeader selectedTab={setSelectedTab} framework={framework} />
            <FrameworkList
                frameworks={frameworks}
                loading={loading}
                selectFramework={handleSelectFramework}
                removeFramework={handleRemoveFramework}
                updateFramework={handleUpdateFramework}
                showTableContent={handleShowTableContent}
                downloadFramework={handleDownloadFramework}
                selectedTab={selectedTab}
                stopTour={stopTour}
                projectId={project.id}
                 />

        </div>
    )
}

export default Construction